import React, { useState, useMemo, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import NavigationMenu from "./navigationMenu.json";

function Navigation({ user, logout, userData, isWalkIn }) {
  const location = useLocation();
  const [isCareerOpen, setCareerOpen] = useState(false);
  const [isProfileMenuOpen, setProfileMenuOpen] = useState(false);
  const [isNavMenuOpen, setNavMenuOpen] = useState(false);
  const [activeDropdownIndex, setActiveDropdownIndex] = useState(null);

  const profile = useMemo(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const data = JSON.parse(storedUser);
      return data.username.charAt(0).toUpperCase();
    }
    return "";
  }, []);

  const isProfile = !userData && !profile;

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 991);
  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth <= 991);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const profileButton = () => {
    if (isProfile) {
      return (
        <div className="d-flex gap-3 order-sm-1 container-md">
          {!(isSmallScreen && isNavMenuOpen) && (
            <>
              <Link
                to="/signup"
                className={`btn text-white rounded-5 fw-bold ${
                  isSmallScreen ? "px-4" : "px-5"
                }`}
                style={{ fontSize: `0.9rem`, backgroundColor: "#D18237" }}
              >
                Sign Up
              </Link>
              <Link
                to="/signin"
                className={`btn text-white rounded-5 fw-bold ${
                  isSmallScreen ? "px-4" : "px-5"
                }`}
                style={{ fontSize: `0.9rem`, backgroundColor: "#256F22" }}
              >
                Login
              </Link>
            </>
          )}
        </div>
      );
    }
    return (
      <div className="d-flex gap-3 order-sm-1 position-relative">
        <div>
          {!(isSmallScreen && isNavMenuOpen) && (
            <div
              className="d-flex rounded-circle align-items-center justify-content-center"
              style={{
                width: "50px",
                height: "50px",
                cursor: "pointer",
                backgroundColor: "#d18237",
              }}
              onClick={() => setProfileMenuOpen(!isProfileMenuOpen)}
            >
              <p className="text-white m-0 fw-bold fs-5">{profile}</p>
            </div>
          )}

          {isProfileMenuOpen && (
            <div
              className="position-absolute bg-white shadow-sm p-2 rounded"
              style={{
                top: "65px",
                transform: "translateX(-50%)",
                minWidth: "150px",
                zIndex: 10,
              }}
            >
              <button
                className="btn text-danger w-100 fw-bold"
                onClick={() => {
                  setProfileMenuOpen(false);
                  logout();
                }}
              >
                Log Out
              </button>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <nav
      className="navbar navbar-expand-lg navbar-light shadow-sm fixed-top py-0 py-md-2"
      style={{ backgroundColor: "#FFFFFF" }}
    >
      <div
        className={`container-fluid  px-2 px-md-5 py-1 d-flex align-items-center justify-content-between ${
          isSmallScreen ? "py-2" : ""
        }`}
      >
        {!isWalkIn && (
          <button
            className="navbar-toggler me-2"
            type="button"
            aria-label="Toggle navigation"
            onClick={() => setNavMenuOpen(!isNavMenuOpen)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
        )}

        {!(isProfile && isSmallScreen) && (
          <Link to="/" style={{ width: "12rem" }} className="me-auto">
            <img src="/lgs.jpeg" alt="Company Logo" className="w-100" />
          </Link>
        )}

        {!isWalkIn && (
          <div
            className={`collapse navbar-collapse justify-content-center ${
              isNavMenuOpen ? "show" : ""
            }`}
            id="navbarNav"
            style={{ flexGrow: 1 }}
          >
            <ul
              className="navbar-nav justify-content-center flex-column flex-lg-row w-100"
              style={{ gap: isSmallScreen ? "0" : "4rem" }}
            >
              {NavigationMenu.map((item, index) => {
                const isActive =
                  location.pathname === item.path ||
                  (item.dropdown &&
                    item.dropdown.some(
                      (subItem) => location.pathname === subItem.path
                    ));

                return (
                  <li
                    key={index}
                    className={`nav-item ${
                      item.dropdown ? "dropdown position-relative" : ""
                    } ${
                      isSmallScreen ? "w-100 text-center border-bottom" : ""
                    }`}
                    style={{
                      backgroundColor:
                        isSmallScreen && isActive ? "#f0f5f1" : "transparent",
                      transition: "background-color 0.3s ease",
                    }}
                  >
                    <div
                      onMouseEnter={() =>
                        item.dropdown && !isSmallScreen && setCareerOpen(true)
                      }
                      onMouseLeave={() =>
                        item.dropdown && !isSmallScreen && setCareerOpen(false)
                      }
                      style={{ position: "relative" }}
                    >
                      <Link
                        className="nav-link fw-bold d-flex align-items-center justify-content-center"
                        to={item.path}
                        onMouseEnter={() => {
                          if (item.dropdown && !isSmallScreen) {
                            setCareerOpen(!isCareerOpen);
                          }
                        }}
                        onClick={() => {
                          if (item.dropdown && isSmallScreen) {
                            setCareerOpen(!isCareerOpen);
                          }
                        }}
                        style={{
                          fontSize: isSmallScreen ? "0.85rem" : "0.9rem",
                          ...(item.style || {}),
                          color: isActive ? "#256F22" : "#4a4a4a",
                          // padding: isSmallScreen ? "" : "",
                          borderRadius: "6px",
                          padding: isSmallScreen ? "15px 0" : "",
                          cursor:
                            item.dropdown && isSmallScreen
                              ? "pointer"
                              : "default",
                          backgroundColor:
                            isActive && isSmallScreen
                              ? "#e6f4ea"
                              : "transparent",
                        }}
                      >
                        {item.name}
                        {item.dropdown && (
                          <span
                            className="d-lg-none ms-2"
                            style={{
                              fontSize: "0.8rem",
                              transform: isCareerOpen
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            ▼
                          </span>
                        )}
                      </Link>

                      {item.dropdown && isCareerOpen && (
                        <ul
                          className={`bg-white text-start border list-unstyled ${
                            isSmallScreen
                              ? "position-static w-100"
                              : "position-absolute"
                          }`}
                          style={{
                            top: isSmallScreen ? "auto" : "100%",
                            left: isSmallScreen ? "0" : "auto",
                            right: isSmallScreen ? "0" : "-100%",
                            transform: isSmallScreen ? "none" : "translateX(0)",
                            zIndex: 1000,
                            minWidth: "200px",
                            width: isSmallScreen ? "100%" : "auto",
                            maxWidth: isSmallScreen ? "none" : "300px",
                          }}
                        >
                          {item.dropdown.map((subItem, subIndex) => (
                            <li
                              key={subIndex}
                              className="border-bottom hover-bg"
                            >
                              <Link
                                className="dropdown-item py-3 px-4 fw-bold"
                                to={subItem.path}
                                style={{
                                  fontSize: `0.85rem`,
                                  color:
                                    location.pathname === subItem.path
                                      ? "#256F22"
                                      : "#333",
                                }}
                                onClick={() => setCareerOpen(false)}
                              >
                                {subItem.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        )}

        <div
          className={
            isSmallScreen
              ? "mobile-profile-section mt-0 d-lg-none mt-md-2"
              : "d-none d-lg-flex"
          }
        >
          {profileButton()}
        </div>
      </div>
    </nav>
  );
}

export default Navigation;
